import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { AccountConfigService } from '../../../services/account-config/account-config.service';
import { SessionService } from '../../../services/session/session.service';
import { ApprenantService } from '../../../services/apprenant/apprenant.service';
import * as moment from 'moment';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { pencilIcon, SVGIcon } from '@progress/kendo-svg-icons';


@Component({
  selector: 'ags-session-prerequis',
  templateUrl: './session-prerequis.component.html',
  styleUrls: ['./session-prerequis.component.scss']
})
export class SessionPrerequisComponent implements OnInit {
  @HostBinding('class') themeFlag;
  public svgPencil: SVGIcon = pencilIcon;
  public dialogOpened = false;
  public dialogTitle: string = void 0;
  public dialogData: {
    id_apprenant_justificatif: any;
    id_prerequis: any;
    id_apprenant: any;
    id_justificatif_statut: any;
    date_debut: any;
    date_fin: any;
    duree_justificatif: any;
  } = {
    id_apprenant_justificatif: null,
    id_prerequis: null,
    id_apprenant: null,
    id_justificatif_statut: 1,
    date_debut: null,
    date_fin: null,
    duree_justificatif: null
  };

  public idSession;
  @Input('idSession')
  set _idSession(value: string) {
    if (value) {
      this.idSession = value;
    }
  }
  public expandMode: number = PanelBarExpandMode.Single;
  public statut_session: any = [
    {
      id: 1,
      libelle: 'en attente de validation',
      couleur: 'statut-1',
      selected: true
    },
    {
      id: 2,
      libelle: 'validé',
      couleur: 'statut-2',
      selected: false
    },
    {
      id: 3,
      libelle: 'à renouveler',
      couleur: 'statut-3',
      selected: false
    }
  ];

  public loadingPrerequis = false;
  public loadingDocs = false;

  public listPrerequis: any;
  public listApprenant: any;

  private saveItem: {
    id: any;
    id_prerequis: any;
    id_apprenant: any;
    id_justificatif_statut: any;
    date_debut: any;
    date_fin: any;
  };

  // public fileNameUpload: String;

  constructor(
    private accountConfigService: AccountConfigService,
    private sessionService: SessionService,
    private apprenantService: ApprenantService
  ) // private documentService: DocumentService
  {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    this.getApprenantsSession(this.idSession);
  }

  // Liste Apprenant
  getApprenantsSession(idSession) {
    this.apprenantService.getApprenantBySession(idSession).subscribe((apprenantsSessionData: any) => {
      this.listApprenant = apprenantsSessionData.filter(el => el.id_apprenant != null);
    });
  }

  // Liste Pre-requis par Apprenant
  getPrerequisSession(idSession, idApprenant) {
    this.loadingPrerequis = true;
    this.sessionService.getSessionApprenantPrerequis(idSession, idApprenant).subscribe((prerequisSessionData: any) => {
      this.listPrerequis = prerequisSessionData;
      this.loadingPrerequis = false;
    });
  }

  // Event changement d'apprenant
  onPanelChange($event) {
    const item = $event.items.find(el => el.selected === true);
    this.getPrerequisSession(this.idSession, Number(item.id));
  }

  // Event ouverture Pop-up
  openPrerequisPopup(prerequis, apprenant) {
    this.dialogTitle = `Fiche du Documents Justificatif - ${prerequis.libelle}`;

    this.dialogData.id_apprenant = apprenant.id_apprenant;
    this.dialogData.id_prerequis = prerequis.id_prerequis;
    this.dialogData.date_debut = prerequis.date_debut ? new Date(prerequis.date_debut) : null;
    this.dialogData.date_fin = prerequis.date_fin ? new Date(prerequis.date_fin) : null;
    this.dialogData.duree_justificatif = prerequis.duree_justificatif;
    this.dialogData.id_justificatif_statut = prerequis.id_justificatif_statut;
    this.dialogData.id_apprenant_justificatif = prerequis.id_apprenant_justificatif;
    if (this.dialogData.id_justificatif_statut) {
      this.selectStatut(this.dialogData.id_justificatif_statut);
    }

    this.loadingDocs = true;
    // this.getDocument(this.dialogData.id_apprenant_justificatif);
    this.dialogOpened = true;
  }

  // Recuperation info de statut
  getStatut(type, idStatut) {
    const currentStatut = this.statut_session.find(el => {
      return Number(el.id) === Number(idStatut) ? el : null;
    });
    if (currentStatut) {
      switch (type) {
        case 'libelle':
          return currentStatut.libelle;
        case 'color':
          return currentStatut.couleur;
        case 'statut':
          return true;
      }
    }
    return false;
  }

  // Evet Selection de statut
  selectStatut(id_status) {
    this.statut_session.forEach(el => {
      if (el.selected === true) el.selected = false;
      if (Number(el.id) === Number(id_status)) el.selected = true;
    });
    this.dialogData.id_justificatif_statut = id_status;
  }

  // Recup couleur statut avec disabled
  getColor(status) {
    return status.selected ? status.couleur : 'statut-disabled';
  }

  // Event Changement date debut
  dateDebutChange($event) {
    const newDate = moment($event)
      .add(Number(this.dialogData.duree_justificatif) || 0, 'M')
      .toString();
    this.dialogData.date_fin = new Date(newDate);
  }

  // Event fermeture pop-up
  closeDialog(close: string, dialogData: any = null): void {
    if (close === 'save' && dialogData != null) {
      this.saveItem = {
        id: dialogData.id_apprenant_justificatif || null,
        id_prerequis: dialogData.id_prerequis || null,
        id_apprenant: dialogData.id_apprenant || null,
        id_justificatif_statut: dialogData.id_justificatif_statut.toString() || null,
        date_debut: dialogData.date_debut ? moment(dialogData.date_debut).format('YYYY-MM-DD') : null,
        date_fin: dialogData.date_fin ? moment(dialogData.date_fin).format('YYYY-MM-DD') : null
      };
      this.sessionService.updateSessionApprenantPrerequis(this.saveItem).subscribe(res => {
        this.getPrerequisSession(this.idSession, this.dialogData.id_apprenant);
        this.dialogData = {
          id_apprenant_justificatif: null,
          id_prerequis: null,
          id_apprenant: null,
          id_justificatif_statut: 1,
          date_debut: null,
          date_fin: null,
          duree_justificatif: null
        };
        this.dialogOpened = false;
      });

    } else {
      this.getPrerequisSession(this.idSession, this.dialogData.id_apprenant);
      this.dialogData = {
        id_apprenant_justificatif: null,
        id_prerequis: null,
        id_apprenant: null,
        id_justificatif_statut: 1,
        date_debut: null,
        date_fin: null,
        duree_justificatif: null
      };
      this.dialogOpened = false;
    }
  }
}
